"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styles_1 = require("@material-ui/core/styles");

var Table_1 = __importDefault(require("@material-ui/core/Table"));

var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));

var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));

var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));

var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));

var lodash_1 = __importDefault(require("lodash"));

var SchemaRenderer_1 = __importDefault(require("../SchemaRenderer"));

var styles = function styles(theme) {
  return {
    table: {
      background: theme.palette.grey[50]
    }
  };
};

var JSONSchemaFields = function (_super) {
  __extends(JSONSchemaFields, _super);

  function JSONSchemaFields() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  JSONSchemaFields.prototype.render = function () {
    var _a = this.props,
        schema = _a.schema,
        classes = _a.classes,
        name = _a.name,
        required = _a.required,
        hideHeader = _a.hideHeader;

    if (!schema) {
      return null;
    }

    if (lodash_1.default.isEmpty(schema)) {
      return null;
    }

    return react_1.default.createElement(react_1.default.Fragment, null, !hideHeader && react_1.default.createElement(Table_1.default, {
      className: classes.table
    }, react_1.default.createElement(TableHead_1.default, null, react_1.default.createElement(TableRow_1.default, null, react_1.default.createElement(TableCell_1.default, null, "Name"), react_1.default.createElement(TableCell_1.default, null, "Title"), react_1.default.createElement(TableCell_1.default, null, "Type"), react_1.default.createElement(TableCell_1.default, null, "Pattern"), react_1.default.createElement(TableCell_1.default, null, "Required"), react_1.default.createElement(TableCell_1.default, null, "Description"))), react_1.default.createElement(TableBody_1.default, null, react_1.default.createElement(SchemaRenderer_1.default, {
      schema: schema,
      required: required,
      name: name
    }))), hideHeader && react_1.default.createElement(SchemaRenderer_1.default, {
      schema: schema,
      required: required,
      name: name
    }));
  };

  return JSONSchemaFields;
}(react_1.Component);

var WrappedJSONSchemaFields = styles_1.withStyles(styles)(JSONSchemaFields);
exports.default = WrappedJSONSchemaFields;